var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "title-card h-100",
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-card', {
    staticClass: "title-card__top w-100 mb-6 mb-lg-10",
    attrs: {
      "elevation": "0",
      "rounded": "lg",
      "color": _vm.color
    }
  }, [_c('div', {
    staticClass: "w-100 pa-12 pa-lg-20"
  }, [_c('h4', {
    staticClass: "tit--sm line-height-1 text-center white--text"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])])]), _c('v-card', {
    staticClass: "title-card__bottom w-100",
    attrs: {
      "elevation": "0",
      "rounded": "lg",
      "color": "white"
    }
  }, [_c('v-layout', {
    staticClass: "w-100 h-100 text-center pa-12 pa-md-20",
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_vm._t("default")], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }